import BaseLayout from "../layouts/base";
import {
  cscConnectApiBaseUri,
  cscConnectClientIdDra,
  cscConnectCallbackUriDra,
  onboardingPortalBaseURL,
  onboardingPortalBaseURLBCBF,
  cscConnectCallbackUriBcbf,
  cscConnectClientIdBcbf,
} from "../config";
import usePromise from "../utils/hooks/usePromise";
import { services } from "../services";
import { prependZeroes } from "../utils/func";
import { useAuth } from "../utils/hooks/useAuth";

export default function LoginPage() {
  const {
    authState: { is_authenticated },
    validatingToken,
  } = useAuth();

  console.log(JSON.stringify({ is_authenticated, validatingToken }, null, 2));

  usePromise(
    {
      fn: async () => {
        if (!validatingToken && !is_authenticated) {
          const { count: cscAuthAttemptsCount } =
            await services.requestSvc.get<{
              count: number;
            }>("/get-incremented-cscc-auth-attempts-count");

          const hostname = window?.location?.hostname;
          let cscConnectCallBackUri = "";
          let cscConnectClientId = "";

          if (hostname === onboardingPortalBaseURL) {
            cscConnectCallBackUri = cscConnectCallbackUriDra;
            cscConnectClientId = cscConnectClientIdDra;
          } else if (hostname === onboardingPortalBaseURLBCBF) {
            cscConnectCallBackUri = cscConnectCallbackUriBcbf;
            cscConnectClientId = cscConnectClientIdBcbf;
          }

          console.log("hey i am here", hostname);
          console.log("hey i am cscConnectApiBaseUri", cscConnectApiBaseUri);
          console.log("hey i am cscConnectApiBaseUri", cscConnectApiBaseUri);

          const redirectURL = `${cscConnectApiBaseUri}/authorize?response_type=code&client_id=${cscConnectClientId}&redirect_uri=${encodeURIComponent(
            cscConnectCallBackUri
          )}&state=${prependZeroes(cscAuthAttemptsCount, 8)}`;

          window.location.href = redirectURL;
        }
      },
      runOnMount: { args: [] },
      runOnRerender: { args: [], enabled: true },
    },
    [validatingToken, is_authenticated]
  );

  return (
    <BaseLayout>
      <div className="flex flex-col mt-8 gap-y-4">
        <span className="text-lg">Validating session...</span>
      </div>
    </BaseLayout>
  );
}
